import React from "react";
import PropTypes from "prop-types";
import { Trans, useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import BrokerAvatar from "../../../components/mui/material/BrokerAvatar";
import NumericFormat from "../../../components/react-number-format/NumericFormat";
import { incomeTypeIds } from "../../../constants";
var tKey = "wrappers.NotificationToastsDecorator.impl.DepositPendingNotificationListItem";
function DepositPendingNotificationListItem(props) {
  var notificationId = props.notificationId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var notification = useSelector(function (state) {
    return state.entities.notifications.byId[notificationId];
  });
  var operationId = notification.event.objects[0].objectId;
  var operation = useSelector(function (state) {
    return state.entities.operations.byId[operationId];
  });
  var headerKey;
  var bodyKey;
  if (operation.incomeType && (operation.incomeType.id === incomeTypeIds.INTEREST || operation.incomeType.id === incomeTypeIds.BOND_INTEREST)) {
    headerKey = "".concat(tKey, ".header_interestsReceived");
    bodyKey = "".concat(tKey, ".body_interestsReceived");
  } else if (operation.incomeType && operation.incomeType.id === incomeTypeIds.DIVIDEND) {
    headerKey = "".concat(tKey, ".header_dividendsReceived");
    bodyKey = "".concat(tKey, ".body_dividendsReceived");
  } else if (operation.incomeType && operation.incomeType.id === incomeTypeIds.BOND_AMORTIZATION) {
    headerKey = "".concat(tKey, ".header_amortizationReceived");
    bodyKey = "".concat(tKey, ".body_amortizationReceived");
  } else {
    headerKey = "".concat(tKey, ".header_depositReceived");
    bodyKey = "".concat(tKey, ".body_depositReceived");
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-shrink-0 me-2"
  }, /*#__PURE__*/React.createElement(BrokerAvatar, {
    broker: operation.broker
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex-grow-1"
  }, /*#__PURE__*/React.createElement("div", null, t(headerKey), "\xA0\xB7\xA0", moment(notification.createdAt).fromNow(true)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: bodyKey,
    components: {
      small: /*#__PURE__*/React.createElement("small", null),
      investmentItemAmount: /*#__PURE__*/React.createElement(NumericFormat, {
        displayType: "text",
        decimalScale: operation.investmentItem.unitDecimalScale,
        value: operation.investmentItemAmount,
        className: "me-1 fw-bold"
      }),
      lnk: /*#__PURE__*/React.createElement(Link, {
        to: "/pending-deposits"
      })
    },
    values: {
      unitAbbreviation: operation.investmentItem.unitAbbreviation,
      brokerName: operation.broker.name
    }
  }))));
}
export default DepositPendingNotificationListItem;
DepositPendingNotificationListItem.propTypes = {
  notificationId: PropTypes.number.isRequired
};